import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiCustomersList, apiCustomersView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/customers/getData', async datas => {
    const { data } = await apiCustomersList(datas)
    return data
})

export const getView = createAsyncThunk('admin/customers/getView', async id => {
    if (!id) return viewData
    const { data } = await apiCustomersView(id)
    data.image = ''
    return data
})

const viewData = {
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    firm_name: '',
    password: '',
    password_confirmation: '',
    image: '',
    address: '',
    country: '',
    state: '',
    city: '',
    pincode: '',
}

export const customersSlice = createSlice({
    name: 'admin/customers',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = customersSlice.actions

export default customersSlice.reducer
